import { Col, H4, H5, IconLockup, PortableText, Row, SpacerWrapper } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import FeatureHighlight from '../../inclusions/section/feature-highlight';
import FootnoteLink from '../../../../../components/footnote-link';
import type { FeatureOrBenefitItem } from '../../../types';

type FeatureOrBenefitsSectionProps = {
  items: FeatureOrBenefitItem[];
  type: 'addons' | 'benefits' | 'inclusions';
};

const TYPE_PROPS = {
  addons: { icon: 'plus', title: 'Add ons', type: 'partial' },
  benefits: { icon: 'tick', title: 'Additional benefits', type: 'included' },
  inclusions: { icon: 'tick', title: 'What’s included', type: 'included' },
};

const StyledIconLockup = styled(IconLockup)`
  .icon {
    margin-top: 0.625rem;
  }
`;

const markSerializers = {
  // @ts-expect-error - Automatic, Please fix when editing this file
  footnote: ({ mark, children }) => (
    <span>
      {children}
      <FootnoteLink footnoteSymbol={mark.footnoteSymbol} />
    </span>
  ),
};

const FeaturesOrBenefitsSection = ({ items, type }: FeatureOrBenefitsSectionProps) => {
  if (isEmpty(items)) {
    return null;
  }

  const { title, icon, type: iconType } = TYPE_PROPS[type] || {};
  return (
    <SpacerWrapper variant="marginTopSpacer7">
      <H4>{title}</H4>
      <Row>
        {map(
          ({ callout, descriptionRaw, footnoteLinkSymbol, title: itemTitle }) => (
            <Col key={itemTitle} df={4} sm={6} xs={12} variant="marginTopSpacer10">
              <StyledIconLockup icon={{ className: 'icon', name: `${icon}-circle`, size: 'small', type: iconType }}>
                <H5>
                  {itemTitle}
                  {footnoteLinkSymbol && <FootnoteLink footnoteSymbol={footnoteLinkSymbol} />}
                  {callout && [' ', <FeatureHighlight key={callout} text={callout} />]}
                </H5>
                {descriptionRaw && <PortableText markSerializers={markSerializers} source={descriptionRaw} />}
              </StyledIconLockup>
            </Col>
          ),
          items,
        )}
      </Row>
    </SpacerWrapper>
  );
};

export default FeaturesOrBenefitsSection;
